import * as SwitchPrimitives from '@radix-ui/react-switch'
import clsx from 'clsx'
import * as React from 'react'

import { Cross } from '@/components-latest/primitives/Icons'
import Spinner from '@/components-latest/primitives/Spinner'

import Styles from './Switch.module.scss'

type Props = {
  checked: boolean
  onCheckedChange?: (checked: boolean) => void
  disabled?: boolean
  isLoading?: boolean
  className?: string
  'data-testid'?: string
}

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  Props
>(({ checked, onCheckedChange, disabled, isLoading, className, ...props }, ref) => {
  return (
    <SwitchPrimitives.Root
      ref={ref}
      className={clsx(Styles.root, className)}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled || isLoading}
      data-testid={props['data-testid'] ?? 'switch'}>
      <SwitchPrimitives.Thumb className={Styles.thumb}>
        {isLoading ? (
          <Spinner />
        ) : (
          !checked && <Cross className={Styles.icon} width={10} height={10} />
        )}
      </SwitchPrimitives.Thumb>
    </SwitchPrimitives.Root>
  )
})

Switch.displayName = 'Switch'

export default Switch
